import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

/**
 * "Already have an account? Log in" / "New to MagicFurnish? Create an account"
 * Apple-style: muted label + primary-weight action link, centered, 44px tap target.
 */
export default function AuthSwitchLink({ mutedText, linkText, to, sx: sxProp }) {
  return (
    <Box
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      justifyContent="center"
      alignItems="center"
      columnGap={0.5}
      rowGap={0.5}
      sx={{ mt: 1, ...sxProp }}
    >
      <Typography
        sx={{
          fontSize: "14px",
          color: "rgba(0,0,0,0.55)",
          lineHeight: 1,
        }}
      >
        {mutedText}
      </Typography>
      <Box
        component={Link}
        to={to}
        sx={{
          fontSize: "14px",
          fontWeight: 600,
          color: "var(--brand-color, #006766)",
          textDecoration: "none",
          minHeight: 44,
          display: "inline-flex",
          alignItems: "center",
          pl: 0.5,
          "&:hover": { textDecoration: "underline" },
        }}
      >
        {linkText}
      </Box>
    </Box>
  );
}
